import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "placeholder", "status", "nameInput"]
  static values = { autoUrl: String }

  connect() {
    this.showPreview(this.autoUrlValue || this.nameInputTarget?.value || "")
  }

  preview(event) {
    this.showPreview(event.target.value)
  }

  fetchAutoLogo() {
    const name = this.nameInputTarget?.value
    if (!name) return

    fetch("/teams/auto_logo?name=" + encodeURIComponent(name))
      .then(r => r.json())
      .then(data => {
        if (data.url) {
          this.showPreview(data.url)
        }
      })
  }

  showPreview(url) {
    if (!url) {
      this.previewTarget.classList.add("hidden")
      this.placeholderTarget.classList.remove("hidden")
      this.statusTarget.textContent = ""
      return
    }

    this.previewTarget.classList.remove("hidden")
    this.placeholderTarget.classList.add("hidden")
    this.previewTarget.src = url

    if (url.includes("flag-icons")) {
      this.statusTarget.textContent = "Escudo automático via flag-icons"
    } else if (url.includes("football-logos")) {
      this.statusTarget.textContent = "Escudo via luukhopman/football-logos"
    } else {
      this.statusTarget.textContent = "Escudo personalizado"
    }
  }
}
